import {environment} from "src/environments/environment";

export class ApiRoutes {
  static Authentication = `${environment.baseApiUrl}/api/auth/`;
  static DomainCode = `${environment.baseApiUrl}/api/domain_code/`;
  static ContainerMaster = `${environment.baseApiUrl}/api/container_master/`;
  static CurrencyMaster = `${environment.baseApiUrl}/api/currency_master/`;
  static Location = `${environment.baseApiUrl}/api/depot_master/location/`;
  static CustomerMaster = `${environment.baseApiUrl}/api/customer_master/customer/`;
  static Geo = `${environment.baseApiUrl}/api/geo/`;
  static Document = `${environment.baseApiUrl}/api/document/`;
  static DocumentType = `${environment.baseApiUrl}/api/document/document_type/`;
  static DepotMaster = `${environment.baseApiUrl}/api/depot_master/`;
  static Company = `${environment.baseApiUrl}/api/company/`;
  static ChargeMaster = `${environment.baseApiUrl}/api/charge_master/`;
  static Core = `${environment.baseApiUrl}/api/core/`;
  static LeadRequest = `${environment.baseApiUrl}/api/requests/`;
  static Insurance = `${environment.baseApiUrl}/api/insurance/`;
  static UserService = `${environment.baseApiUrl}/api/user_service/`;
  static Booking = `${environment.baseApiUrl}/api/booking/`;
  static ChatToken = `${environment.baseApiUrl}/api/auth/websocket_token/`;
  static SocketUrl = `${environment.socketApiUrl}/ws/`;
  static MNR = `${environment.baseApiUrl}/api/mnr/`;
  static Chat = `${environment.baseApiUrl}/api/chat/`;
  static SentDocumentsUrl = `${environment.baseApiUrl}/api/chat/thread/`;
  static NotificationStatusUrl = `${environment.baseApiUrl}/api/chat/notification/`;
  static UOM = `${environment.baseApiUrl}/api/uom/`;
  static QuoteConfirmEmailUrl = `${environment.baseApiUrl}/api/external_api/sendgrid/mail/`;
  static Reports = `${environment.baseApiUrl}/api/reports/`;
  static TMS = `${environment.baseApiUrl}/api/tms/`;
  static HSN = `${environment.baseApiUrl}/api/hsn/`;
  static Scribble = `${environment.baseApiUrl}/api/notes/scratchpad/`;
  static Arthakosh = `${environment.baseApiUrl}/api/arthakosh/`;
  static Dashboard = `${environment.baseApiUrl}/api/dashboards/`;
  static Approval = `${environment.baseApiUrl}/api/approvals/`;
  static BookingCharge = `${environment.baseApiUrl}/api/booking_charge/`;

}
export class ApiRelativeRoutes {
  static Dashboard = `/api/dashboards/`;
  static Report = `/api/reports/`;

}
